import React, { useState, useMemo } from 'react';
import { Grid, Card, Icon, Button, Accordion, List, Label, Segment } from 'semantic-ui-react';
import { documentationContent } from '../data/documentationContent';
import DocumentationViewer from './DocumentationViewer';
import { useAuth } from '../../../context/AuthContext';

const DocumentationSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const { hasRole } = useAuth();

  // Filtrar documentações baseado em permissões
  const visibleDocumentation = useMemo(() => {
    return documentationContent.filter(item => {
      // Se a categoria é "Administração", apenas Admin pode ver
      if (item.category === 'Administração') {
        return hasRole('Admin') || hasRole('admin');
      }
      // Outras categorias são visíveis para todos
      return true;
    });
  }, [hasRole]);

  const handleClick = (index: number) => {
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const getCategoryColor = (category: string) => {
    const colors: { [key: string]: string } = {
      'Introdução': 'blue',
      'Contratos': 'green',
      'Clientes': 'purple',
      'Planos': 'orange',
      'WhatsApp': 'teal',
      'Relatórios': 'red',
      'Administração': 'grey',
      'Boas Práticas': 'yellow'
    };
    return colors[category] || 'blue';
  };

  return (
    <div>
      <Segment>
        <h3 style={{ marginBottom: '20px', color: '#2c3e50' }}>
          <Icon name="book" />
          Documentação do Sistema
        </h3>

        <Accordion fluid styled>
          {visibleDocumentation.map((item, index) => (
            <div key={item.id}>
              <Accordion.Title
                active={activeIndex === index}
                index={index}
                onClick={() => handleClick(index)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '16px 20px',
                  background: activeIndex === index ? '#f8f9fa' : 'white'
                }}
              >
                <Icon name={item.icon as any} color={getCategoryColor(item.category) as any} />
                <div style={{ flex: 1, marginLeft: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                    <strong style={{ fontSize: '16px' }}>{item.title}</strong>
                    <Label color={getCategoryColor(item.category) as any} size="tiny">
                      {item.category}
                    </Label>
                  </div>
                  <p style={{ color: '#666', margin: '4px 0', fontSize: '14px' }}>
                    {item.description}
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px', fontSize: '12px', color: '#888' }}>
                    <span><Icon name="clock" />{item.readTime}</span>
                    <span><Icon name="calendar" />Atualizado em {item.lastUpdated}</span>
                  </div>
                </div>
                <Icon name="dropdown" style={{ marginLeft: 'auto' }} />
              </Accordion.Title>

              <Accordion.Content active={activeIndex === index}>
                <div style={{ padding: '20px' }}>
                  <div style={{ marginBottom: '16px' }}>
                    <strong>Tags relacionadas:</strong>
                    <div style={{ marginTop: '8px' }}>
                      {item.tags.map((tag: string, tagIndex: number) => (
                        <Label key={tagIndex} size="tiny" style={{ marginRight: '8px', marginBottom: '4px' }}>
                          {tag}
                        </Label>
                      ))}
                    </div>
                  </div>

                  <DocumentationViewer content={item.content} />
                </div>
              </Accordion.Content>
            </div>
          ))}
        </Accordion>
      </Segment>

      <Segment>
        <h4 style={{ marginBottom: '16px', color: '#2c3e50' }}>
          <Icon name="question circle" />
          Precisa de Ajuda?
        </h4>
        <p style={{ color: '#666', marginBottom: '16px' }}>
          Se você não encontrou a documentação que precisa ou tem dúvidas específicas sobre o sistema,
          entre em contato com a equipe de suporte.
        </p>
        <Button secondary disabled>
          <Icon name="mail" />
          Contatar Suporte
        </Button>
      </Segment>
    </div>
  );
};

export default DocumentationSection;
